export default "__VITE_PUBLIC_ASSET__7baa2f42__"